module.exports = __webpack_public_path__ + "img/图片10.53b90de5.png";